import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { Bulto } from '@/__env/lib/Expedicion/Guias/Bultos';
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { Wait } from '@/__env/ext';

export class ControladorDeBultos extends ControladorBase
{
    
}